import { z } from "zod";

/** Client-safe lead schema shared by the contact + proposal forms. */
export const leadSchema = z.object({
  name: z.string().trim().min(2, "Please enter your name.").max(100),
  email: z.string().trim().toLowerCase().email("Please enter a valid work email.").max(255),
  company: z.string().trim().max(150).optional().default(""),
  phone: z.string().trim().max(40).optional().default(""),
  service: z.string().trim().max(150).optional().default(""),
  message: z.string().trim().min(10, "Please tell us a little more (10+ characters).").max(2000),
  source: z.string().trim().max(60).optional().default("contact_page"),
  /** Honeypot — must stay empty. */
  website: z.string().max(200).optional().default(""),
  /** Client timestamp (ms) of when the form was rendered. */
  renderedAt: z.number().int().nonnegative().optional().default(0),
});

export type LeadInput = z.input<typeof leadSchema>;

export type LeadResult =
  | { ok: true }
  | {
      ok: false;
      reason: "invalid" | "rate_limited" | "spam" | "error";
      message: string;
      retryAfter?: number;
    };
